export const formContent = {
    heading: 'Add product',
    productName: {
        id: 'title',
        label: 'Product name',
        validation: {
            required: "Please enter product name"
        }
    },
    description: {
        id: 'description',
        label: 'Description'
    },
    category: {
        id: 'categoryId',
        label: 'Select category',
        options: [],
        validation: {
            required: "Please select a category"
        }
    },
    productBuyType: {
        id: 'productBuyType',
        label: 'Product buy type',
        options: [
            { value: 'Buy', label: 'Buy' },
            { value: 'Hire', label: 'Hire' },
            { value: 'Rent', label: 'Rent' }
        ],
        validation: {
            required: "Select a product buy type"
        }
    },
    priceType: {
        id: 'priceType',
        options: [],
        validation: {
            required: "Select a price type"
        }
    },
    price: {
        id: 'price',
        label: 'Price(per day)',
        type: 'number',
        validation: {
            required: "Please enter product price"
        }
    },
    renewalOption: {
        id: 'renualOption',
        label: 'Renewal options',
        options: [
            { value: 'Automatic', label: 'Automatic' },
            { value: 'Manual', label: 'Manual' }
        ],
        validation: {
            required: "Select a product buy type"
        }
    },
    productType: {
        id: 'productType',
        label: 'Product type',
        options: [
            { value: 'Physical', label: 'Physical' },
            { value: 'Digital', label: 'Digital' }
        ],
        validation: {
            required: "Select a product type"
        }
    },
    productImages: {
        id: 'productImages',
        label: 'Upload product images'
    },
    addProductButton: {
        id: 'addProductButton',
        label: 'Add product',
        type: 'submit'
    }
}
